import { action, makeAutoObservable, makeObservable, runInAction } from "mobx"
import { AbsLoopsModel } from '../loops/model'

import { fetchMyLoops, getMyRecentPacks } from './MyLibraryAPI'


class MyLoopsModel extends AbsLoopsModel {

  constructor() {
    super()
    makeObservable(this, {
      load: action,
      toMyLoops: action
    })
    this.loopState = 'myloops'
  }

  load = async () => {
    this.loading = true
    try {
      const rs = await fetchMyLoops(this.queryParams)
      this.setLoopsData(rs)
    } finally {
      runInAction(() => this.loading = false)
    }
  }

  toMyLoops = () => {
    this.reset()
    this.load()
  }

}

// "thumbnail": "https://sessionloops.oss-cn-beijing.aliyuncs.com/packs/mask-off/thumbnail.png",
//             "banner": "https://sessionloops.oss-cn-beijing.aliyuncs.com/packs/mask-off/banner.png",
//             "title": "Mask Off",
//             "demo": "https://sessionloops.oss-cn-beijing.aliyuncs.com/packs/mask-off/demo.mp3",
//             "url": "Mask+Off",
//             "content": "This is another awesome pack of RnB style.",
//             "samples": "",
//             "cover": "https://sessionloops.oss-cn-beijing.aliyuncs.com/packs/mask-off/cover.png",
//             "grooveCount": 0,
//             "lickCount": 0,
//             "id": 1,
//             "tag": "R&B",
//             "config": "https://sessionloops.oss-cn-beijing.aliyuncs.com/packs/mask-off/samples.config"

class MyRecentPacksModel {
  
    constructor() {
      makeAutoObservable(this)
    }

    packs = []

    loading = false

    load = async() => {
      this.loading = true
      try {
        const rs = await getMyRecentPacks()
        runInAction(() => this.packs = rs || [])
      } catch(e) {
        console.error('load fail', e)
      } finally {
        runInAction(() => this.loading = false)
      }
    }
}

export { MyLoopsModel, MyRecentPacksModel }